module.exports = __webpack_public_path__ + "img/points-o.37f88c72.svg";